import {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  useQuery as reactQueryUseQuery,
} from 'react-query'

import { environment } from 'utils/constants'
import { formatQueryResults } from 'utils/formatResults'
import { Log } from 'utils/logger'

export const useQuery = <TData = unknown>(
  key: QueryKey,
  inputFunction: QueryFunction<TData, QueryKey>,
  options?: Omit<UseQueryOptions<TData, unknown, TData, QueryKey>, 'queryKey' | 'queryFn'>,
) => {
  const queryResults = reactQueryUseQuery<TData>(key, inputFunction, {
    onError: (error) => {
      Log.error(`useQuery onError in ${key}`, error)
    },
    staleTime: 60000,
    retry: environment.isDev ? false : 3,
    ...options,
  })

  return formatQueryResults(queryResults)
}
